import { CreativeBean, ItemResponseCreativeBeanObject } from 'common/api/api.ts'
import { BaseApi, configuration } from 'common/api/BaseApi.ts'
import { callBackend, processError } from 'common/api/fetch.ts'

class CreativeFetchCall extends BaseApi {

  create(
    creative: CreativeBean,
    icon: File | undefined,
    media: File | undefined,
    nativeUploadImageList: File[] = [],
    nativeUploadVideoList: File[] = [],
  ): Promise<ItemResponseCreativeBeanObject> {

    const data = this.getData(creative, icon, media, nativeUploadImageList, nativeUploadVideoList)

    return callBackend(configuration.basePath + '/api/creative', {
      method: 'POST',
      body: data
    })
      .then((response) => {
        if (!response.ok) throw response
        return response.json()
      })
      .catch((err) => processError(err))
  }

  edit(
    id: number | string,
    creative: CreativeBean,
    icon: File | undefined,
    media: File | undefined,
    nativeUploadImageList: File[] = [],
    nativeUploadVideoList: File[] = [],
  ): Promise<ItemResponseCreativeBeanObject> {

    const data = this.getData(creative, icon, media, nativeUploadImageList, nativeUploadVideoList)

    return callBackend(configuration.basePath + `/api/creative/${id}`, {
      method: 'POST',
      body: data
    })
      .then((response) => {
        if (!response.ok) throw response
        return response.json()
      })
      .catch((err) => processError(err))
  }

  private getData(
    creative: CreativeBean,
    icon?: File,
    media?: File,
    nativeUploadImageList: File[] = [],
    nativeUploadVideoList: File[] = [],
  ): FormData {

    const data = new FormData()

    data.append('bean', JSON.stringify(creative))

    if (icon instanceof File) {
      data.append('icon', icon)
    }
    if (media instanceof File) {
      data.append('media', media)
    }

    nativeUploadImageList
      .filter(Boolean)
      .forEach(img => data.append('nativeImages', img))

    nativeUploadVideoList
      .filter(Boolean)
      .forEach(video => data.append('nativeVideos', video))

    return data
  }
}

const creativeFetchCall = new CreativeFetchCall()

export default creativeFetchCall
